var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-12" }, [
    _c("div", [
      _c(
        "div",
        {
          staticClass: "catalog-side-card",
          class: { "full-text": _vm.fullText },
          style: { transform: "none", opacity: _vm.disabled ? 0.4 : 1 },
        },
        [
          _c("div", { staticClass: "catalog-side-card__wrapper" }, [
            !this.hideThumbnail
              ? _c("div", { staticClass: "side-card-preview" }, [
                  _c("img", {
                    staticClass: "preview",
                    attrs: { src: _vm.thumbSrc, alt: _vm.thumbAlt },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "catalog-side-card__wrapper__container" },
              [
                _c("div", { staticClass: "side-card-content" }, [
                  _c(
                    "div",
                    { staticClass: "side-card-content__left-container" },
                    [
                      _c("div", { staticClass: "side-card-info" }, [
                        _c("div", { staticClass: "side-card-info__title" }, [
                          _c("span", [_vm._v(_vm._s(_vm.title))]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            ref: "sideCardDesc",
                            staticClass: "side-card-info__desc",
                          },
                          [
                            _c("span", [
                              _c("div", [_vm._v(_vm._s(_vm.description))]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "side-card-info__caption" }, [
                          _c("span", [
                            _c("div", [
                              !this.hideIdentifier
                                ? _c("div", { staticClass: "identifier" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.identifier) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", [
                                _vm.missingReference
                                  ? _c("small", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "alert alert-danger small p-0",
                                          attrs: { role: "alert" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            Missing OGC reference metadata\n                                        "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              !this.hideExpand
                                ? _c(
                                    "div",
                                    {
                                      ref: "descriptionRuler",
                                      staticClass: "ms-ruler",
                                      staticStyle: {
                                        visibility: "hidden",
                                        height: "0px",
                                        "white-space": "nowrap",
                                        position: "absolute",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.description) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "side-card-content__right-container" },
                    [
                      _c("div", { staticClass: "side-card-tool text-center" }, [
                        _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm btn-main min-w-auto btn-add",
                              attrs: {
                                type: "button",
                                "data-toggle": "tooltip-city",
                                title: "Adicionar ao mapa",
                              },
                              on: { click: _vm.onLayerAdd },
                            },
                            [_c("span", { staticClass: "fas fa-plus" })]
                          ),
                          _vm._v(" "),
                          _vm.visibleExpand
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-main min-w-auto",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "tooltip-city",
                                    title: _vm.fullText ? "Collapse" : "Expand",
                                  },
                                  on: { click: _vm.onFullText },
                                },
                                [
                                  _c("span", {
                                    staticClass: "fas",
                                    class: _vm.fullText
                                      ? "fa-chevron-down"
                                      : "fa-chevron-left",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "side-card-loading" }, [
      _c("div", { staticClass: "side-card-loader" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }